import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import ConnexionReducer from "./reducers/ConnexionReducer";
import MessagerieReducer from "reducers/MessagerieReducer";
import AccountValidationReducer from "./reducers/AccountValidationReducer";
import BlacklistReducer from 'reducers/BlacklistReducer';
import RequestPassReducer from './reducers/RequestPassReducer';

export default function configureStore(initialState = {}) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    return createStore(combineReducers({
        Connexion: ConnexionReducer,
        Messagerie: MessagerieReducer,
        AccountValidation: AccountValidationReducer,
        Blacklist: BlacklistReducer,
        RequestPass: RequestPassReducer
    }), composeEnhancers(applyMiddleware(thunk))
    );
}
